import { PATHS } from 'routes/routes.constants';

import Button from '@polyai/ui/components/atoms/Button';
import { ArrowTopRight } from '@polyai/ui/components/atoms/Icons';

import type { ProjectVersionState } from 'api/resources/deployments/types';
import type { useToast } from 'hooks/useToast';
import { generateNextPath } from 'lib/routeHelper';
import { NUM_OF_VERSION_CHARS_TO_SHOW } from 'screens/Environments/constants';

export const getUserFriendlyVersion = (
  version: string | undefined,
  isConflictResolution: boolean = false,
): string => {
  if (version) {
    return isConflictResolution
      ? version
      : version.slice(0, NUM_OF_VERSION_CHARS_TO_SHOW);
  }
  return '';
};

export const transformDisclaimerData = ({
  knowledge_base: data,
}: Pick<ProjectVersionState, 'knowledge_base'>) => {
  return {
    is_enabled: data.disclaimer_enabled,
    message: data.disclaimer_message,
    ringtone: data.disclaimer_ringtone,
    voice_id: data.disclaimer_voice_id,
    ringtone_public_url: data.disclaimer_ringtone_public_url,
    ringtone_filename: data.disclaimer_ringtone_filename,
  };
};

export const handleTestSetRunsTriggered = (
  testRunIds: string[] | undefined,
  toast: ReturnType<typeof useToast>,
  accountId: string,
  projectId: string,
  queryClient: any,
) => {
  const testRunCount = testRunIds?.length || 0;

  if (testRunCount > 0) {
    toast.info({
      title: 'Test set runs started',
      actionButton: (
        <Button
          endAdornment={ArrowTopRight}
          iconColor="iconPrimaryInverse"
          label="View"
          to={generateNextPath(PATHS.TEST_SUITE, {
            accountId,
            projectId,
            type: 'test-sets',
          })}
          variant="SECONDARY"
          inverse
        />
      ),
    });
    queryClient
      .invalidateQueries([accountId, projectId, 'testSets'])
      .catch((e: any) =>
        console.error(
          'Error occurred. Could not invalidate test set queries',
          e,
        ),
      );
  }
};
